var map = {
	"./adult/nn/ordforstaelse-data.json": 690,
	"./adult/no/ordforstaelse-data.json": 691,
	"./youth/de/ordforstaelse-data.json": 692,
	"./youth/nn/ordforstaelse-data.json": 693,
	"./youth/no/ordforstaelse-data.json": 694,
	"./youth/se/ordforstaelse-data.json": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 689;